import React from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { TitleProps } from './models';
import { useTranslation } from '@sunbit-dev/translations';
import { useSelector } from 'react-redux';
import { getStore } from '~/store/reducers/purchase/purchase';
import { PrivacyAllowanceLayer } from '@sunbit-dev/purchase-common/src/components/privacyAllowanceLayer/PrivacyAllowanceLayer';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';
import { formatDisplayFirstName } from '~/helpers/utils';

export const Title = styled(({ className }: TitleProps) => {
  const { t } = useTranslation('landing_page', { keyPrefix: 'welcome_view.title' });

  const { purchaseInfo } = useSelector(getStore);
  const userFirstName = purchaseInfo?.userFirstName;

  return (
    <PrivacyAllowanceLayer privacyLevel={PrivacyOptions.Hidden}>
      <h1 className={className}>
        {userFirstName
          ? t('welcome_with_name', { userFirstName: formatDisplayFirstName(userFirstName) })
          : t('welcome')}
        {t('text')}
      </h1>
    </PrivacyAllowanceLayer>
  );
})`
  ${styles.Title}
`;
